import { onMounted, onBeforeUnmount, useInstance } from 'intact-vue-next';
import { debounce } from '../components/utils';
import ResizeObserver from 'resize-observer-polyfill';
export function useResizeObserver(elementRef, callback, useDebounce) {
  if (useDebounce === void 0) {
    useDebounce = false;
  }
  var instance = useInstance();
  var ro;
  onMounted(function () {
    // use debounce instead of throttle, because if there is
    // transition on parent container, the width is weired
    // #342
    var fn = function fn() {
      if (instance.$unmounted) return;
      callback();
    };
    ro = new ResizeObserver(useDebounce ? debounce(fn, 100, true) : fn);
    ro.observe(elementRef.value);
  });
  onBeforeUnmount(function () {
    if (!ro) return;
    ro.disconnect();
  });
}